Returns the basic metadata of the tenant authenticated by the credential.

<ApiCodeExamples exampleId="metaTenant" />

<ApiResponseExamples exampleId="metaTenant" />

## Main fields in the `200` response

- `id`: authenticated tenant ID.
- `name`: organization display name.
- `email`: tenant primary email.
- `is_active`: whether the tenant is still operationally active.

## When to use this endpoint

- quickly validate which tenant the credential authenticated;
- confirm that the integration is pointing to the right organization;
- run an initial smoke test after creating or rotating a credential.
